import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import type { TooltipActionType } from './types';
export function useTooltipPageAction() {
  const $ = _c(4);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionName: "rating_link_tooltip",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_section: actionSection
      });
    };
    t1 = (actionType_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionSection_0);
    };
    $[2] = firePageAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTooltipClickPageAction = t1;
  return handleTooltipClickPageAction;
}
export function useTooltipPageActionWithoutSkuViewed() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      actionName: "rating_link_tooltip"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[1] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_section: actionSection
      });
    };
    t1 = (actionType_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionSection_0);
    };
    $[1] = firePageAction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleTooltipClickPageAction = t1;
  return handleTooltipClickPageAction;
}